import React from 'react';

import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import sortBy from 'lodash/sortBy';

import { ia, iaRa, io } from 'lib/helpers/utility';
import useDateTimeFormat from 'lib/hooks/useDateTimeFormat';

const ActiveFilterList = ({ useData = () => ({}) }) => {
  const { formatDate } = useDateTimeFormat();
  const { filters, defaultFilters } = useData();

  if (!io(filters)) return null;

  const filterValues = Object?.values(filters)?.map((item) => item.values);
  const defaultFilterValues = Object?.values(defaultFilters)?.map((item) => item.values);

  const noFilterApplied = isEqual(filterValues, defaultFilterValues);
  if (noFilterApplied) return null;

  return (
    <div className="rounded bg-primary-25 p-2">
      <p className="mb-2 text-base text-primary-800">List of Active Filters</p>
      {Object?.keys(filters)?.map((key) => {
        return (
          !isEqual(sortBy(filters[key].values), sortBy(defaultFilters[key]?.values)) && (
            <div className="mb-1 flex justify-between !px-2">
              <p className="text-xs font-medium text-neutral-600">{filters[key].title}</p>
              <p className="text-xs font-medium text-primary-900">
                {filters[key].type === 'date-range'
                  ? formatDate(filters[key].values.startDate) +
                    ' - ' +
                    formatDate(filters[key].values.endDate)
                  : typeof filters[key].values === 'object'
                    ? iaRa(filters[key].values)
                        .map((item) => {
                          if (ia(filters[key]?.options)) {
                            return filters[key]?.options?.find((option) => {
                              const itemToCompare = isString(item) ? item : item.value;
                              return option.value === itemToCompare;
                            })?.label;
                          } else {
                            return item.label;
                          }
                        })
                        .join(' ,')
                    : filters[key].values}
              </p>
            </div>
          )
        );
      })}
    </div>
  );
};

export default ActiveFilterList;
